import React, { createContext, useContext, useState, ReactNode } from 'react';

interface DetailsPanelContextType {
  isOpen: boolean;
  close: () => void;
  open: () => void;
}

const DetailsPanelContext = createContext<DetailsPanelContextType | undefined>(undefined);

export const useDetailsPanel = () => {
  const context = useContext(DetailsPanelContext);
  if (context === undefined) {
    throw new Error('useDetailsPanel must be used within a DetailsPanelProvider');
  }
  return context;
};

export const DetailsPanelProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const close = () => {
    if (isOpen) {
      setIsOpen(false);
    }
  };
  const open = () => {
    if (!isOpen) {
      setIsOpen(true);
    }
  };

  const value = {
    isOpen,
    close,
    open,
  };

  return <DetailsPanelContext.Provider value={value}>{children}</DetailsPanelContext.Provider>;
};
